import { useTranslation } from "react-i18next";
import { Row, Col, HelpText } from "../../App.styles";
import { FormAutocomplete, HelpModal, RowInfo } from "../../common";

const TimerSelect = (props) => {
    const { t } = useTranslation()
    const extendedTimers = [{
        id: 120,
        name: t(`120 (2 minutes)`),
    }, {
        id: 300,
        name: t(`300 (5 minutes)`)
    }, {
        id: 600,
        name: t(`600 (10 minutes)`)
    }, {
        id: 1800,
        name: t(`1800 (30 minutes)`)
    }, {
        id: 3600,
        name: t(`3600 (1 hour)`)
    }]

    return (
        <FormAutocomplete 
          {...props}
          options={[
                ...Array(100)
                  .fill()
                  .map((_, i) => {
                    const seconds = 60
                    const shouldShowMinute = i%seconds === 0 && i > 0
                    const inMinute = i/seconds > 1 ? t(` (${i/seconds} minutes)`) : t(` (${i/seconds} minute)`)
                    return {
                        id: i,
                        name: `${String(i)}${shouldShowMinute ? inMinute : ''}`,
                    }
                  }),
                ...extendedTimers,
          ]}
          size="small"
          creatable
        />
      )
}

const TimersSection = ({ useQuery }) => {
  const { t } = useTranslation();
  
  return (
    <>
      <RowInfo help={(
        <HelpModal title={t(`Timers`)}>
            <p>{t(`Timers give the player finite time to interact with a NPC.`)}</p>
            <p className="mt-2" dangerouslySetInnerHTML={{__html: t(`0 indicates no timer. 
            Other values are seconds. Once the timer has expired, the NPC 
            will simply ignore the player.`)}} />
        </HelpModal>
      )}>
        <TimerSelect
            help={t('If you want to add some pressure, set this above 0.')}
            label={t('Timer in seconds')}
            name="timer"
            useQuery={useQuery}
          />
      </RowInfo>
      <Row>
        <Col size="10">
          <HelpText className="position-relative top-0 mt-4 d-block" focus>
            {t(`Timers give the player finite time to interact with a NPC.`)}
  
            <p className="mt-2" dangerouslySetInnerHTML={{__html: t(`0 indicates no timer. 
            Other values are seconds. Once the timer has expired, the NPC 
            will simply ignore the player.`)}} />
          </HelpText>
        </Col>
      </Row>
    </>
  )
};

export default TimersSection;
